import React from "react";
import { Modal } from "@fluentui/react";
import * as S from "../../SummaryPortfolioModel/Styles/DeleteCompositionModalStyles";
import { IDeleteCompositionModalProps } from "../Interfaces/SummaryPortfolioInterfaces";

const DeleteCompositionModal: React.FC<IDeleteCompositionModalProps> = ({isOpen, onClose, onConfirm, compositionData, isLoading = false}) =>
{
    const handleClose = React.useCallback(() =>
    {
        if(!isLoading)
        {
            onClose();
        }
    }, [onClose, isLoading]);

    const handleConfirm = React.useCallback(() =>
    {
        if(!isLoading)
        {
            onConfirm();
        }
    }, [onConfirm, isLoading]);

    const formatWeight = React.useCallback((weight: number): string =>
    {
        return `${weight.toFixed(2)}%`;
    }, []);

    return(
        <Modal isOpen={isOpen} onDismiss={handleClose} isBlocking={true} containerClassName="modal-container" styles={{main: {width: '45% !important'}}}>
            <S.ModalContainer>
                <S.ModalTitle>
                    Eliminación de la Composición
                </S.ModalTitle>
                <S.ModalBody>
                    <S.WarningText>
                        ¿Estás seguro de que quieres eliminar la siguiente composición? Esta acción es irreversible.
                    </S.WarningText>
                    {compositionData &&
                    (
                        <S.CompositionInfo>
                            <S.CompositionHeader>
                                <S.CompositionDate>{compositionData.date}</S.CompositionDate>
                                <S.FundsCount>{compositionData.funds.length} fondos</S.FundsCount>
                            </S.CompositionHeader>
                            <S.FundsList>
                                {compositionData.funds.map((fund, index) =>
                                (
                                    <S.FundItem key={index}>
                                        <S.FundName>{fund.name}</S.FundName>
                                        <S.FundDetails>
                                            <S.FundIsin>{fund.isin}</S.FundIsin>
                                            <S.FundWeight>{formatWeight(fund.weight).replace(".", ",")}</S.FundWeight>
                                        </S.FundDetails>
                                    </S.FundItem>
                                ))}
                            </S.FundsList>
                        </S.CompositionInfo>
                    )}
                </S.ModalBody>
                <S.ModalFooter>
                    <S.CancelButton onClick={handleClose} disabled={isLoading}>
                        No
                    </S.CancelButton>
                    <S.ConfirmButton onClick={handleConfirm} disabled={isLoading}>
                        {isLoading ? 'Eliminando...' : 'Sí'}
                    </S.ConfirmButton>
                </S.ModalFooter>
            </S.ModalContainer>
        </Modal>
    );
};

export default DeleteCompositionModal;